import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { images } from '../../data/images';
import { usps } from '../../data/navigation';
const ease = [0.23, 1, 0.32, 1] as const;
export function HomeHero() {
  const reduce = useReducedMotion();
  const {
    scrollY
  } = useScroll();
  const scale = useTransform(scrollY, [0, 800], [1, reduce ? 1 : 1.08]);
  return <section className="relative w-full overflow-hidden bg-[#F2D3DC] lg:h-[100svh] lg:min-h-[680px]" data-id="element-44" data-mp="31tq0n73duaat">
      <div className="relative h-[58svh] min-h-[400px] overflow-hidden lg:absolute lg:inset-0 lg:h-full" data-id="element-45" data-mp="2n4tvbhspnbdw">
        <motion.img src={images.hero} alt="Vrouw met een stralende, verzorgde huid in roze satijn" style={{
        scale
      }} className="h-full w-full object-cover object-[78%_30%] lg:object-[70%_35%]" data-id="element-46" data-mp="2s2mxlzqw7l8w" />
      </div>

      <div className="relative mx-auto flex max-w-7xl flex-col px-5 pb-8 pt-10 lg:h-full lg:justify-end lg:px-8 lg:pb-8 lg:pt-0" data-id="element-47" data-mp="3klit90ejhti0">
        <div className="lg:mb-auto lg:mt-[22vh] lg:max-w-[46%]" data-id="element-48" data-mp="jwnz3se6iqdg">
          <motion.p initial={reduce ? false : {
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3,
          delay: 0.1
        }} className="flex items-center gap-2 text-sm text-ink/75" data-id="element-49" data-mp="ju1k57oyl8l7">
            <span className="flex" aria-hidden="true" data-id="element-50" data-mp="17kxg8h0g6py9">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-pink text-pink" strokeWidth={0} data-id="element-51" data-mp="12lu8upwzw7n4" data-mpi={i} />)}
            </span>
            4,8 uit 3.100+ reviews
          </motion.p>
          <h1 className="mt-5 font-display text-[clamp(3rem,7.4vw,7rem)] uppercase leading-[0.92] tracking-display text-ink" data-id="element-52" data-mp="1ckjqchkzbq2u">
            <span className="block overflow-hidden pb-[0.04em]" data-id="element-53" data-mp="3ie9zfqm1pntk">
              <motion.span className="block" initial={reduce ? false : {
              y: '105%'
            }} animate={{
              y: 0
            }} transition={{
              duration: 0.3,
              delay: 0.12,
              ease
            }} data-id="element-54" data-mp="3ecyalnazx6mf">
                Beauty,
              </motion.span>
            </span>
            <span className="block overflow-hidden pb-[0.08em]" data-id="element-55" data-mp="1mb5biky59poa">
              <motion.span className="block" initial={reduce ? false : {
              y: '105%'
            }} animate={{
              y: 0
            }} transition={{
              duration: 0.3,
              delay: 0.19,
              ease
            }} data-id="element-56" data-mp="1r96r2vwd36v0">
                made <em className="italic text-pink" data-id="element-57" data-mp="1w6gg4afu9gib">personal.</em>
              </motion.span>
            </span>
          </h1>
          <motion.div initial={reduce ? false : {
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.3,
          ease
        }} data-id="element-58" data-mp="2597w8njnt0ga">
            <p className="mt-6 max-w-md text-lg font-light leading-relaxed text-ink/80" data-id="element-59" data-mp="2ez14pfoi8zgb">
              Pure Marokkaanse verzorging. Natuurlijk, eerlijk en voor iedereen.
            </p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-60" data-mp="2nzz0jaosi0nt">
              <Link to="/collectie/bestsellers" className="group inline-flex h-14 items-center gap-2 whitespace-nowrap rounded-full bg-ink px-7 text-base font-medium text-white transition-colors duration-150 hover:bg-berry" data-id="element-61" data-mp="2o0iiusicqr2d">
                Shop bestsellers
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-62" data-mp="3ch3ljhs6r20" />
              </Link>
              <Link to="/collectie/voor-haar" className="inline-flex h-14 items-center whitespace-nowrap rounded-full border border-ink/20 bg-white/60 px-7 text-base font-medium text-ink backdrop-blur transition-colors duration-150 hover:border-ink hover:bg-white" data-id="element-63" data-mp="w0mqabseaq4h">
                Voor haar
              </Link>
            </div>
          </motion.div>
        </div>

        <div className="mt-10 flex flex-col gap-6 lg:mt-0 lg:flex-row lg:items-end lg:justify-between" data-id="element-64" data-mp="1equgxuewro3s">
          <ul className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-ink/70" data-id="element-65" data-mp="19zvu0bzezrrk">
            {usps.map(u => <li key={u} className="flex items-center gap-2 whitespace-nowrap" data-id="element-66" data-mp="ui4kp1nrbpgo">
                <span className="h-1.5 w-1.5 rounded-full bg-pink" aria-hidden="true" data-id="element-67" data-mp="ykhfww4vo4z7" />
                {u}
              </li>)}
          </ul>
          <motion.div initial={reduce ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.38,
          ease
        }} data-id="element-68" data-mp="km18f2z6yag0">
            <Link to="/product/hammam-ritueel-set" className="group flex items-center gap-4 rounded-2xl bg-white p-3 pr-5 text-ink shadow-[0_18px_40px_-24px_rgba(107,29,61,0.55)] transition-transform duration-200 hover:-translate-y-0.5 lg:w-[380px]" data-id="element-69" data-mp="1d9nmj561oxh4">
              <img src={images.giftset} alt="" className="h-20 w-20 rounded-xl bg-surface object-cover" data-id="element-70" data-mp="18gb1t64hlatn" />
              <span className="flex-1" data-id="element-71" data-mp="1w6f1j2ek0qfd">
                <span className="block text-xs font-medium text-pink" data-id="element-72" data-mp="20yyhu74mlznv">Meest gekocht</span>
                <span className="block font-semibold" data-id="element-73" data-mp="3lols747ygq1d">Hammam Ritueel Set</span>
                <span className="block text-sm" data-id="element-74" data-mp="3lmis1rd39gix">
                  <span className="font-semibold" data-id="element-75" data-mp="3gopnt3vciwla">€ 59,95</span> <span className="text-muted line-through" data-id="element-76" data-mp="3gno8gn7arnxr">€ 69,75</span>
                </span>
              </span>
              <span className="grid h-10 w-10 place-items-center rounded-full bg-ink text-white transition-colors duration-150 group-hover:bg-pink" data-id="element-77" data-mp="3qfk7q1l4dk3k">
                <ArrowRightIcon className="h-4 w-4" data-id="element-78" data-mp="32qspa1xc0g3z" />
              </span>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>;
}